var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowForwardLtr = function SvgArrowForwardLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.973 87.096c1.297 1.207 3.397 1.205 4.691-.003L92.03 53.138l.06-.058c1.233-1.212 1.213-3.125-.06-4.313l-36.3-33.86-.062-.057c-1.299-1.151-3.353-1.133-4.628.055l-.061.058c-1.235 1.211-1.215 3.127.06 4.316L81.827 48H11l-.176.005A3 3 0 0 0 11 54h70.732L50.97 82.722l-.06.059c-1.234 1.212-1.212 3.127.063 4.315"
  })));
};
export default SvgArrowForwardLtr;